'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (html) {
    var wrapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';
    var old = arguments[2];

    var filter = old ? gentleOldFilter : gentleFilter;
    var safeHtml = filter.process(html).trim();
    try {
        safeHtml = htmlToReactParser.parse('<' + wrapper + '>' + safeHtml + '</' + wrapper + '>');
    } catch (e) {
        safeHtml = bruteFilter.process(html).trim();
    }
    return safeHtml;
};

var _htmlToReact = require('html-to-react');

var _xss = require('xss');

var _xss2 = _interopRequireDefault(_xss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// gently remove disallowed tags
var gentleOptions = {
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style'],
    whiteList: {
        a: ['alt', 'href', 'target'],
        b: [],
        br: [],
        i: [],
        img: ['width', 'height', 'src', 'srcset', 'title'],
        li: [],
        ol: [],
        p: [],
        strong: [],
        ul: []
    }
};
var gentleFilter = new _xss2.default.FilterXSS(gentleOptions);

var gentleOldOptions = {
    stripIgnoreTag: true,
    stripIgnoreTagBody: ['script', 'style', 'img'],
    whiteList: {
        a: ['alt', 'target'],
        b: [],
        br: [],
        i: [],
        li: [],
        ol: [],
        p: [],
        strong: [],
        ul: []
    }
};
var gentleOldFilter = new _xss2.default.FilterXSS(gentleOldOptions);

// Create a filter for removing all the html in the case that we fail parsing
var bruteOptions = {
    stripIgnoreTag: true, // filter out all HTML not in the whilelist
    stripIgnoreTagBody: ['script', 'style'], // the script tag is a special case, we need to filter out its content
    whiteList: [] // empty, means filter out all tags
};
var bruteFilter = new _xss2.default.FilterXSS(bruteOptions);

var htmlToReactParser = new _htmlToReact.Parser();

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/safelyRender.js
// module id = YLee
// module chunks = 46